module.exports = __webpack_public_path__ + "static/media/spotify.50083c54.png";